// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { INewbuildingSeoGeoDistance } from '../geo/NewbuildingSeoGeoDistance';
import type { INewbuildingBooking } from '../newbuilding/NewbuildingBooking';
import type { INewbuildingReviewStat } from '../newbuilding_review_stats/NewbuildingReviewStat';
import type { INewbuildingAddressElement } from '../geo/NewbuildingAddressElement';
import type { IGeoUndergroundForSerp } from './GeoUndergroundForSerp';
import type { ISellerForSerp } from './SellerForSerp';
import type { IBuilderForSerp } from './BuilderForSerp';
import type { INewbuildingFeatureV2 } from '../newbuilding_features_v2/NewbuildingFeatureV2';
import type { INewbuildingMaterial } from '../common/NewbuildingMaterial';
import type { IRoomStats } from '../newbuilding_stats/RoomStats';
import type { INewbuildingLabel } from '../newbuilding_label/NewbuildingLabel';
import type { IImageForSerp } from './ImageForSerp';

export interface INewbuildingForSerpItem {
  /** ID ЖК **/
  id?: TNewbuildingForSerpItem_Id;
  /** Удаленность ЖК от SEO гео **/
  seoGeoDistance?: TNewbuildingForSerpItem_SeoGeoDistance;
  /** Флаг отображения надежности ЖК **/
  showReliableFlag?: TNewbuildingForSerpItem_ShowReliableFlag;
  /** Название для отображения **/
  displayName: string;
  /** Название ЖК **/
  name?: TNewbuildingForSerpItem_Name;
  /** Является ли ЖК проблемным **/
  isProblem: boolean;
  /** Информация по бронированию квартир в ЖК **/
  booking?: TNewbuildingForSerpItem_Booking;
  /** Доступна сельская ипотека **/
  villageMortgageAllowed?: TNewbuildingForSerpItem_VillageMortgageAllowed;
  /** Признак наличия тура в данном ЖК **/
  hasTour?: TNewbuildingForSerpItem_HasTour;
  /** Является лидером продаж **/
  isSalesLeader?: TNewbuildingForSerpItem_IsSalesLeader;
  /** Статистика отзывов по ЖК **/
  reviewStat?: TNewbuildingForSerpItem_ReviewStat;
  /** Информация о сдаче ЖК **/
  specialStatusDisplay?: TNewbuildingForSerpItem_SpecialStatusDisplay;
  /** Параметры для аналитики **/
  gaLabels: object;
  /** ЖК в избранном **/
  isFavorite: boolean;
  /** Список адресных элементов **/
  addressLine: INewbuildingAddressElement[];
  /** Описание ЖК **/
  description: string;
  /** Информация о метро **/
  undergroundInfo?: TNewbuildingForSerpItem_UndergroundInfo;
  /** Информация о продавцах **/
  sellers: ISellerForSerp[];
  /** Список застройщиков **/
  builders: IBuilderForSerp[];
  /** Особенности жк **/
  newbuildingFeaturesV2?: TNewbuildingForSerpItem_NewbuildingFeaturesV2;
  /** Ссылка на выдачу объявлений от агентов **/
  fromAgentsPropsLink: string;
  /** Есть корпуса c продажей по ФЗ-214 **/
  isFz_214: boolean;
  /** Материал отделки ЖК **/
  firstMaterial?: TNewbuildingForSerpItem_FirstMaterial;
  /** Количество квартир от агентов **/
  fromAgentsPropsCount: number;
  /** Ссылка на выдачу объявлений от застройщика **/
  fromDeveloperPropsLink: string;
  /** Строка с кол-вом квартир от агентов **/
  fromAgentsCountsDisplay: string;
  /** Строка с кол-вом квартир от застройщика **/
  fromDeveloperCountsDisplay: string;
  /** Статистика по квартирам от застройщика **/
  fromDevelopersRooms: IRoomStats[];
  /** Список лейблов **/
  labels: INewbuildingLabel[];
  /** Количество квартир от застройщика **/
  fromDeveloperPropsCount: number;
  /** Изображения ЖК **/
  images: IImageForSerp[];
  /** ID региона ЖК **/
  regionId: number;
  /** Производилась ли подмена номера застройщика для сделки **/
  isDealRequestSubstitutionPhone: boolean;
  /** URL на сайте cian.ru **/
  url: string;
  /** Текст старта продаж **/
  salesStartLabel?: TNewbuildingForSerpItem_SalesStartLabel;
  /** Скоро в продаже **/
  isUpcomingSale: boolean;
  /** Типы офферов в ЖК **/
  offerTypes: string;
  /** Статус сравнения ЖК **/
  comparisonStatus?: TNewbuildingForSerpItem_ComparisonStatus;
}

export type TNewbuildingForSerpItem_Id = null | number;

export type TNewbuildingForSerpItem_SeoGeoDistance = null | INewbuildingSeoGeoDistance;

export type TNewbuildingForSerpItem_ShowReliableFlag = null | boolean;

export type TNewbuildingForSerpItem_Name = null | string;

export type TNewbuildingForSerpItem_Booking = null | INewbuildingBooking;

export type TNewbuildingForSerpItem_VillageMortgageAllowed = null | boolean;

export type TNewbuildingForSerpItem_HasTour = null | boolean;

export type TNewbuildingForSerpItem_IsSalesLeader = null | boolean;

export type TNewbuildingForSerpItem_ReviewStat = null | INewbuildingReviewStat;

export type TNewbuildingForSerpItem_SpecialStatusDisplay = null | string;

export type TNewbuildingForSerpItem_UndergroundInfo = null | IGeoUndergroundForSerp;

export type TNewbuildingForSerpItem_NewbuildingFeaturesV2 = null | TNewbuildingForSerpItem_NewbuildingFeaturesV2_1;

export type TNewbuildingForSerpItem_NewbuildingFeaturesV2_1 = INewbuildingFeatureV2[];

export type TNewbuildingForSerpItem_FirstMaterial = null | INewbuildingMaterial;

export type TNewbuildingForSerpItem_SalesStartLabel = null | string;

export type TNewbuildingForSerpItem_ComparisonStatus = null | EComparisonStatus;

export enum EComparisonStatus {
  /** Уже добавлено в сравнение **/
  'Added' = 'added',
  /** Доступно для добавления в сравнение **/
  'Available' = 'available',
  /** Недоступно для добавления в сравнение **/
  'Unavailable' = 'unavailable',
}
